import { render, staticRenderFns } from "./PatronymicNameInput.vue?vue&type=template&id=3840638a&"
import script from "./PatronymicNameInput.vue?vue&type=script&lang=js&"
export * from "./PatronymicNameInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports